import { CertificateModelSectionProps } from "@/src/sections/banner-model/certificate";

export const certificateSectionData_en: CertificateModelSectionProps = {
   cards: [
      {
         img: "/assets/images/certificate/CCIE.png"
      },
      {
         img: "/assets/images/certificate/ewptx.png"
      },
      {
         img: "/assets/images/certificate/PMP.png"
      },
      {
         img: "/assets/images/certificate/ITIL.png"
      },
      {
         img: "/assets/images/certificate/NSE7.png"
      },
      {
         img: "/assets/images/certificate/mcsd.png"
      },
      {
         img: "/assets/images/certificate/MTCINE.png"
      },
      {
         img: "/assets/images/certificate/hcia.png"
      },
      {
         img: "/assets/images/certificate/crestron.png"
      },
      {
         img: "/assets/images/certificate/HP.png"
      },
      {
         img: "/assets/images/certificate/johnson.png"
      },
      {
         img: "/assets/images/certificate/knx.png"
      },
      {
         img: "/assets/images/certificate/milestone.png"
      },
      {
         img: "/assets/images/certificate/motorola.png"
      },
      {
         img: "/assets/images/certificate/pioneers academy.png"
      },
      {
         img: "/assets/images/certificate/solid works.png"
      },
      {
         img: "/assets/images/certificate/trendmicro.png"
      },
      {
         img: "/assets/images/certificate/vmware.png"
      },
   ],
};